import { createContext, useContext, useState, useEffect } from "react";
import { LANGS, more } from "./i18n-extra";

export { LANGS };

const dict = {
  sk: {
    nav: { home: "Domov", properties: "Nehnuteľnosti", destinations: "Destinácie", about: "O nás", contact: "Kontakt" },
    slogan: "Kde vaše sny dostávajú svoju adresu.",
    heroEyebrow: "Luxusné nehnuteľnosti vo svete",
    scroll: "Skrolujte",
    search: { title: "Nájdite svoju vysnívanú nehnuteľnosť", location: "Všetky lokality", type: "Typ nehnuteľnosti", bedrooms: "Spálne", price: "Cenové rozpätie", go: "Hľadať", any: "Ľubovoľné" },
    types: { villa: "Vila", apartment: "Apartmán", penthouse: "Penthouse", house: "Dom", land: "Pozemok" },
    status: { sale: "Na predaj", rent: "Na prenájom" },
    featured: "Vybrané nehnuteľnosti",
    viewAll: "Všetky nehnuteľnosti",
    lifestyleEyebrow: "Luxury real estate worldwide",
    lifestyleTitle1: "Viac než nehnuteľnosti.",
    lifestyleTitle2: "Životný štýl.",
    lifestyleText: "Objavte výnimočné nehnuteľnosti po celom svete. Od slnečného Stredomoria cez exkluzívne destinácie až po prémiové lokality na Slovensku.",
    aboutBtn: "O MEVALUX",
    destEyebrow: "Destinácie",
    destTitle: "Objavte najžiadanejšie miesta sveta",
    propertiesCount: "nehnuteľností",
    ctaTitle: "Vaša ďalšia adresa začína rozhovorom.",
    ctaText: "Diskrétne, osobne a s citom pre detail. Povedzte nám, o čom snívate.",
    ctaBtn: "Kontaktujte nás",
    priceOnRequest: "Cena na vyžiadanie",
    beds: "Spálne", baths: "Kúpeľne", area: "Plocha",
    inquiry: { title: "Mám záujem o nehnuteľnosť", name: "Meno a priezvisko", email: "E-mail", phone: "Telefón", message: "Správa", consent: "Súhlasím so spracovaním osobných údajov podľa", gdpr: "zásad GDPR", send: "Odoslať dopyt", sent: "Ďakujeme, váš dopyt bol odoslaný. Čoskoro sa vám ozveme.", error: "Odoslanie zlyhalo, skúste to prosím znova." },
    description: "Popis",
    video: "Video",
    gallery: "Galéria",
    noResults: "Pre zvolené kritériá sme nenašli žiadne nehnuteľnosti.",
    all: "Všetky",
    aboutTitle: "Kde sa sny stretávajú s adresou.",
    aboutText: "MEVALUX PROPERTY je butiková značka prémiových nehnuteľností. Prinášame výnimočné vily, rezidencie a apartmány v najkrajších destináciách sveta a postupne aj na Slovensku. Každú nehnuteľnosť vyberáme s dôrazom na atmosféru, kvalitu a emóciu, ktorú v vás prebudí.",
    values: [["Diskrétnosť", "Osobný a dôverný prístup ku každému klientovi."], ["Výber", "Len nehnuteľnosti, ktoré by sme si vybrali aj sami."], ["Svet", "Stredomorie, exotické destinácie aj Slovensko."]],
    contactTitle: "Napíšte nám",
    contactText: "Radi vám pomôžeme nájsť nehnuteľnosť, ktorá sa stane vaším domovom.",
    footer: { nav: "Navigácia", legal: "Informácie", contact: "Kontakt", terms: "Obchodné podmienky", gdpr: "Ochrana osobných údajov", cookies: "Cookies", rights: "Všetky práva vyhradené." },
    cookie: { text: "Používame cookies na zlepšenie vášho zážitku a analýzu návštevnosti.", accept: "Prijať všetky", necessary: "Iba nevyhnutné", more: "Viac informácií" },
    back: "Späť na ponuku",
    marquee: ["Španielsko", "Portugalsko", "Taliansko", "Grécko", "Francúzsko", "Dubaj", "Slovensko"],
  },
  en: {
    nav: { home: "Home", properties: "Properties", destinations: "Destinations", about: "About us", contact: "Contact" },
    slogan: "Where Your Dreams Find an Address.",
    heroEyebrow: "Luxury real estate worldwide",
    scroll: "Scroll",
    search: { title: "Find your perfect property", location: "All locations", type: "Property type", bedrooms: "Bedrooms", price: "Price range", go: "Search", any: "Any" },
    types: { villa: "Villa", apartment: "Apartment", penthouse: "Penthouse", house: "House", land: "Land" },
    status: { sale: "For sale", rent: "For rent" },
    featured: "Featured properties",
    viewAll: "View all properties",
    lifestyleEyebrow: "Luxury real estate worldwide",
    lifestyleTitle1: "More Than Properties.",
    lifestyleTitle2: "A Lifestyle.",
    lifestyleText: "Discover exceptional properties around the world. From the sunny Mediterranean through exclusive destinations to premium locations in Slovakia.",
    aboutBtn: "About MEVALUX",
    destEyebrow: "Destinations",
    destTitle: "Explore the World's Most Desirable Locations",
    propertiesCount: "properties",
    ctaTitle: "Your next address begins with a conversation.",
    ctaText: "Discreet, personal and attentive to detail. Tell us what you dream of.",
    ctaBtn: "Contact us",
    priceOnRequest: "Price on request",
    beds: "Bedrooms", baths: "Bathrooms", area: "Area",
    inquiry: { title: "I'm interested in this property", name: "Full name", email: "E-mail", phone: "Phone", message: "Message", consent: "I agree to the processing of personal data under the", gdpr: "privacy policy", send: "Send inquiry", sent: "Thank you, your inquiry has been sent. We will be in touch shortly.", error: "Sending failed, please try again." },
    description: "Description",
    video: "Video",
    gallery: "Gallery",
    noResults: "No properties match the selected criteria.",
    all: "All",
    aboutTitle: "Where dreams meet an address.",
    aboutText: "MEVALUX PROPERTY is a boutique premium real estate brand. We present exceptional villas, residences and apartments in the world's most beautiful destinations, and increasingly in Slovakia. Every property is selected for its atmosphere, quality and the emotion it awakens.",
    values: [["Discretion", "A personal, confidential approach to every client."], ["Curation", "Only properties we would choose for ourselves."], ["Worldwide", "The Mediterranean, exotic destinations and Slovakia."]],
    contactTitle: "Get in touch",
    contactText: "We will gladly help you find the property that becomes your home.",
    footer: { nav: "Navigation", legal: "Information", contact: "Contact", terms: "Terms & Conditions", gdpr: "Privacy Policy", cookies: "Cookies", rights: "All rights reserved." },
    cookie: { text: "We use cookies to improve your experience and analyse traffic.", accept: "Accept all", necessary: "Necessary only", more: "Learn more" },
    back: "Back to listings",
    marquee: ["Spain", "Portugal", "Italy", "Greece", "France", "Dubai", "Slovakia"],
  },
};

const merge = (base, add) => {
  const out = { ...base };
  Object.entries(add || {}).forEach(([k, v]) => {
    out[k] = v && typeof v === "object" && !Array.isArray(v) && base[k] && typeof base[k] === "object" && !Array.isArray(base[k]) ? { ...base[k], ...v } : v;
  });
  return out;
};
const full = Object.fromEntries(LANGS.map(([l]) => [l, merge(merge(dict.en, merge(dict[l] || {}, {})), more[l])]));
full.en = merge(dict.en, more.en);
full.sk = merge(dict.sk, more.sk);

const Ctx = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const s = localStorage.getItem("mx_lang");
    return full[s] ? s : "sk";
  });
  useEffect(() => {
    localStorage.setItem("mx_lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "he" ? "rtl" : "ltr";
  }, [lang]);
  const tr = (obj) => (obj && typeof obj === "object" ? obj[lang] || obj.en || obj.sk || "" : obj || "");
  return <Ctx.Provider value={{ lang, setLang, t: full[lang], tr }}>{children}</Ctx.Provider>;
};

export const useLang = () => useContext(Ctx);
